
export const roomsData = [
  {
    id: 'shibuya-studio',
    title: {
      ja: '渋谷プレミアムスタジオ - 東京タワービュー',
      en: 'Shibuya Premium Studio - Tokyo Tower View',
      zh: '涩谷高级工作室 - 东京塔景观'
    },
    location: {
      ja: '東京都渋谷区',
      en: 'Shibuya, Tokyo',
      zh: '东京都涩谷区'
    },
    price: 180000,
    size: '25㎡',
    type: {
      ja: '1K',
      en: '1K',
      zh: '1K'
    },
    description: {
      ja: '渋谷の中心部に位置し、東京タワーの美しい景色を楽しめるプレミアムスタジオ。モダンな内装と充実した設備で、快適な東京生活をお約束します。',
      en: 'Premium studio located in the heart of Shibuya with beautiful Tokyo Tower views. Modern interior and excellent amenities ensure a comfortable Tokyo lifestyle.',
      zh: '位于涩谷中心地带的高级工作室，可欣赏东京塔的美丽景色。现代化的内装和完善的设施，保证舒适的东京生活。'
    },
    amenities: {
      ja: ['東京タワービュー', 'エアコン', 'キッチン', 'バス・トイレ別', 'インターネット', '家具付き', 'セキュリティ', '24時間管理'],
      en: ['Tokyo Tower View', 'Air Conditioning', 'Kitchen', 'Separate Bath/Toilet', 'Internet', 'Furnished', 'Security', '24h Management'],
      zh: ['东京塔景观', '空调', '厨房', '浴室卫生间分离', '网络', '带家具', '安保', '24小时管理']
    },
    images: [
      "https://public.readdy.ai/ai/img_res/33c9210faa2a8c310962dfd18fbbf546.jpg",
      "https://readdy.ai/api/search-image?query=Tokyo%20Tower%20view%20from%20apartment%20window%20during%20sunset%2C%20spectacular%20city%20panorama%20from%20high-rise%20residential%20building%2C%20warm%20golden%20lighting%2C%20urban%20landscape%20with%20modern%20skyscrapers%2C%20romantic%20evening%20atmosphere%2C%20premium%20location%20viewpoint&width=800&height=600&seq=shibuya-studio-2&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Compact%20modern%20kitchen%20in%20Japanese%20studio%20apartment%2C%20efficient%20design%20with%20built-in%20appliances%2C%20clean%20white%20cabinets%2C%20small%20dining%20area%2C%20contemporary%20fixtures%2C%20functional%20layout%20for%20urban%20living&width=800&height=600&seq=shibuya-studio-3&orientation=landscape"
    ]
  },
  {
    id: 'shinjuku-1ldk',
    title: {
      ja: '新宿ラグジュアリー1LDK - 東京タワービュー',
      en: 'Shinjuku Luxury 1LDK - Tokyo Tower View',
      zh: '新宿豪华1LDK - 东京塔景观'
    },
    location: {
      ja: '東京都新宿区',
      en: 'Shinjuku, Tokyo',
      zh: '东京都新宿区'
    },
    price: 280000,
    size: '45㎡',
    type: {
      ja: '1LDK',
      en: '1LDK',
      zh: '1LDK'
    },
    description: {
      ja: '新宿の高層階から東京タワーを一望できるラグジュアリーアパートメント。広々としたリビングと独立したベッドルームで、ゆとりある生活空間を提供します。',
      en: 'Luxury apartment with panoramic Tokyo Tower views from high floors in Shinjuku. Spacious living area and separate bedroom provide comfortable living space.',
      zh: '位于新宿高层的豪华公寓，可俯瞰东京塔全景。宽敞的客厅和独立卧室，提供舒适的生活空间。'
    },
    amenities: {
      ja: ['東京タワービュー', 'エアコン', 'システムキッチン', 'バス・トイレ別', '高速インターネット', '家具付き', 'コンシェルジュ', '駐車場'],
      en: ['Tokyo Tower View', 'Air Conditioning', 'System Kitchen', 'Separate Bath/Toilet', 'High-speed Internet', 'Furnished', 'Concierge', 'Parking'],
      zh: ['东京塔景观', '空调', '系统厨房', '浴室卫生间分离', '高速网络', '带家具', '礼宾服务', '停车场']
    },
    images: [
      "https://readdy.ai/api/search-image?query=Luxury%201LDK%20apartment%20living%20room%20with%20floor-to-ceiling%20windows%20showcasing%20Tokyo%20Tower%20view%2C%20modern%20Japanese%20interior%20design%2C%20premium%20furniture%2C%20spacious%20layout%2C%20elegant%20decor%2C%20high-end%20residential%20building%20in%20Shinjuku&width=800&height=600&seq=shinjuku-1ldk-1&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Separate%20bedroom%20in%20luxury%20Tokyo%20apartment%20with%20Tokyo%20Tower%20view%2C%20comfortable%20king-size%20bed%2C%20modern%20minimalist%20design%2C%20large%20windows%2C%20premium%20bedding%2C%20peaceful%20sleeping%20environment%2C%20urban%20skyline%20background&width=800&height=600&seq=shinjuku-1ldk-2&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Modern%20system%20kitchen%20in%20luxury%20Japanese%20apartment%2C%20high-end%20appliances%2C%20granite%20countertops%2C%20ample%20storage%20space%2C%20contemporary%20design%2C%20functional%20layout%2C%20premium%20residential%20interior&width=800&height=600&seq=shinjuku-1ldk-3&orientation=landscape"
    ]
  },
  {
    id: 'roppongi-suite',
    title: {
      ja: '六本木エグゼクティブスイート - 東京タワービュー',
      en: 'Roppongi Executive Suite - Tokyo Tower View',
      zh: '六本木行政套房 - 东京塔景观'
    },
    location: {
      ja: '東京都港区六本木',
      en: 'Roppongi, Minato, Tokyo',
      zh: '东京都港区六本木'
    },
    price: 450000,
    size: '80㎡',
    type: {
      ja: '2LDK',
      en: '2LDK',
      zh: '2LDK'
    },
    description: {
      ja: '六本木の最高級エリアに位置するエグゼクティブスイート。東京タワーを間近に望む特等席で、最上級の東京生活を体験できます。',
      en: 'Executive suite located in the premium area of Roppongi. Front-row seat to Tokyo Tower offering the ultimate Tokyo living experience.',
      zh: '位于六本木高级区域的行政套房。近距离欣赏东京塔的特等席，体验最高级的东京生活。'
    },
    amenities: {
      ja: ['東京タワー至近ビュー', '床暖房', 'アイランドキッチン', 'ジャグジー付きバス', 'ギガインターネット', 'デザイナーズ家具', 'コンシェルジュ24h', 'ジム・プール'],
      en: ['Close Tokyo Tower View', 'Floor Heating', 'Island Kitchen', 'Jacuzzi Bath', 'Giga Internet', 'Designer Furniture', '24h Concierge', 'Gym & Pool'],
      zh: ['东京塔近景', '地暖', '岛式厨房', '按摩浴缸', '千兆网络', '设计师家具', '24小时礼宾', '健身房泳池']
    },
    images: [
      "https://readdy.ai/api/search-image?query=Luxury%20executive%20suite%20living%20room%20with%20spectacular%20close-up%20Tokyo%20Tower%20view%2C%20premium%20interior%20design%2C%20designer%20furniture%2C%20spacious%20layout%2C%20floor-to-ceiling%20windows%2C%20elegant%20modern%20decor%2C%20high-end%20residential%20building%20in%20Roppongi&width=800&height=600&seq=roppongi-suite-1&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Master%20bedroom%20in%20executive%20suite%20with%20Tokyo%20Tower%20view%2C%20king-size%20bed%2C%20luxury%20bedding%2C%20modern%20minimalist%20design%2C%20large%20windows%20overlooking%20Tokyo%20Tower%2C%20premium%20residential%20interior%2C%20peaceful%20atmosphere&width=800&height=600&seq=roppongi-suite-2&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Luxury%20island%20kitchen%20in%20executive%20apartment%2C%20high-end%20appliances%2C%20marble%20countertops%2C%20modern%20design%2C%20spacious%20layout%2C%20premium%20fixtures%2C%20contemporary%20Japanese%20residential%20interior&width=800&height=600&seq=roppongi-suite-3&orientation=landscape"
    ]
  }
];
